import * as React from 'react'
import { SVGProps } from 'react'
const SvgChange = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M7.332 4.639A8.016 8.016 0 0 1 19.345 8.7H15.6a.9.9 0 1 0 0 1.8h6a.9.9 0 0 0 .9-.9V3.601a.9.9 0 0 0-1.8 0v3.645a9.814 9.814 0 0 0-18.219.89.9.9 0 1 0 1.703.583 8.014 8.014 0 0 1 3.148-4.08ZM3.3 16.754V20.4a.9.9 0 0 1-1.8 0v-6a.9.9 0 0 1 .9-.9h6a.9.9 0 1 1 0 1.8H4.655a8.014 8.014 0 0 0 12.013 4.062 8.014 8.014 0 0 0 3.148-4.08.9.9 0 0 1 1.703.583 9.813 9.813 0 0 1-15.78 4.182A9.814 9.814 0 0 1 3.3 16.754Z'
      fill={props.color ?? '#CC3E76'}
    />
  </svg>
)
export default SvgChange
